import styled from 'styled-components'
import { ReactComponent as PrototypeSvg } from '@sketch/icons/prototype-hotspot-16'

export const Container = styled.div`
  display: flex;
`

export const Icon = styled(PrototypeSvg)`
  width: 16px;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  flex-shrink: 0;
`

export const Label = styled.div`
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  font-size: ${({ theme }) => theme.fontSizes.D};
  margin-left: 6px; /* stylelint-disable-line scales/space */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
